import React from 'react';
import './Offer.css';
import exclusiveImage from '../Assets/exclusive_image.png';

const Offer = () => {
    return(
        <div className="offer">
            <div className="offer__left">
                <h1>Exclussive</h1>
                <h1>50% OFF</h1>
                <p>For New Customers</p>
                <button>Shop Now</button>
            </div>
            <div className="offer__right">
                <img src={exclusiveImage} alt="Exclusive Offer"/>  
            </div>          
        </div>
    );
}
export default Offer;